<template>
    <div class="titulo-servicio-section">
        <h2 class="titulo-servicio-title fuente-posm">
            Inteligencia que eleva tu nivel de servicio
        </h2>
    </div>
</template>

<script>
export default {
    name: 'TituloServicioNew'
}
</script>

<style lang="css" scoped>
.titulo-servicio-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    background-color: #272727;
}

.titulo-servicio-title {
    color: var(--color-5);
    font-size: 80px;
    line-height: 1.1;
    text-align: center;
    margin: 0;
    max-width: 850px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .titulo-servicio-title {
        font-size: 70px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .titulo-servicio-section {
        padding: 100px 20px 40px 20px;
    }

    .titulo-servicio-title {
        font-size: 35px;
    }
}
</style>
